import React, { useEffect, useState } from "react";
import classNames from "classnames";

const compareDates = (dt1, dt2) => {
  if (!dt1 || !dt2) {
    return false;
  }
  return dt1?.toDateString() === dt2?.toDateString();
};

function MonthSection({
  currentMonth,
  currentYear,
  monthName,
  beginDate,
  endDate,
  setBegin,
  setEnd,
  minDate,
  maxDate,
  singleDateSelect,
  singleDateHighlightOnly,
  handleSingleDateSelect,
}) {
  const [selectedDate, setSelectedDate] = useState(null);

  const currentDate = new Date(); // Получаем текущую дату
  const firstDayOfMonth = new Date(currentYear, currentMonth, 1).getDay(); // Получаем день недели первого дня текущего месяца (воскресенье - 0)
  const shiftedFirstDayOfMonth = (firstDayOfMonth + 6) % 7; // Сдвигаем первый день недели, чтобы понедельник был первым днем (понедельник - 0)
  const calculatedMinDate = minDate ? minDate : currentDate;

  const totalDaysInMonth = new Date(
    currentYear,
    +currentMonth + 1,
    0,
  ).getDate(); // Получаем общее количество дней в текущем месяце

  useEffect(() => {
    // console.log("render month", beginDate, endDate);
  }, [beginDate, endDate]);

  const handleDateClick = (date) => {
    if (maxDate && date > maxDate) return; // Не позволяем выбрать дату позже maxDate
    // if (date < calculatedMinDate) return; // Не позволяем выбрать дату раньше minDate

    if (singleDateSelect) {
      // выбор единственной даты
      handleSingleDateSelect(date);
    } else {
      // выбор периода дат
      setSelectedDate(date);
      if (!beginDate) {
        // начальная дата не выбрана - установить
        // console.log("!beginDate", beginDate);
        setBegin(date);
      } else if (!endDate) {
        // конечная дата не выбрана - установить
        // console.log("!endDate", endDate);
        if (date < beginDate) {
          setBegin(date);
        } else {
          // console.log("else");
          setEnd(date);
        }
      } else {
        // начальная и конечная дата установлены, обнулить конечную, поменять начальную
        // console.log("setBeginsetBegin");
        setBegin(date);
      }
    }
  };

  // Создаем массив дат текущего месяца
  const dates = [];
  for (let day = 1; day <= totalDaysInMonth; day++) {
    dates.push(new Date(currentYear, currentMonth, day));
  }

  // Разбиваем массив дат по неделям
  const weeks = [];
  let week = [];
  for (let i = 0; i < shiftedFirstDayOfMonth; i++) {
    week.push(null); // Добавляем пустые ячейки перед первым днем месяца
  }
  for (let i = 0; i < dates.length; i++) {
    const date = dates[i];
    week.push(date);
    if (week.length === 7) {
      weeks.push(week);
      week = [];
    }
  }
  if (week.length > 0) {
    while (week.length < 7) {
      week.push(null); // Добавляем пустые ячейки после последнего дня месяца
    }
    weeks.push(week);
  }

  // Функция для отображения ячейки календаря
  const renderCell = (date, index) => {
    if (date === null) {
      return <div className="month__day empty" key={`empty-${index}`}></div>;
    }

    const isBeforeMin =
      date < calculatedMinDate && !compareDates(calculatedMinDate, date);
    const isAfterMax =
      maxDate && date > maxDate && !compareDates(maxDate, date);

    if (isBeforeMin || isAfterMax) {
      return (
        <div className="month__day inactive" key={date.getDate()}>
          {date.getDate()}
        </div>
      );
    } else {
      const isWeekend = date.getDay() === 0 || date.getDay() === 6;
      const isCurrent = compareDates(currentDate, date);
      const isSelected = singleDateSelect && compareDates(beginDate, date);
      const inRange =
        (beginDate && endDate && date >= beginDate && date <= endDate) ||
        (singleDateSelect && date >= beginDate);

      return (
        <div
          className={classNames("month__day", {
            current: isCurrent,
            active: !singleDateHighlightOnly && inRange,
            selected: isSelected && singleDateHighlightOnly,
            begin: !singleDateHighlightOnly && compareDates(beginDate, date),
            end: !singleDateSelect && compareDates(endDate, date),
            weekend: isWeekend,
            "single-date": singleDateHighlightOnly,
            "single-active":
              singleDateHighlightOnly && compareDates(beginDate, date),
          })}
          key={date.getDate()}
          onClick={() => handleDateClick(date)}
        >
          {date.getDate()}
        </div>
      );
    }
  };

  return (
    <div className="monthSection">
      <div className="month__title">
        {monthName} {currentYear}
      </div>
      <div className="month__dates">
        {weeks.map((week, index) => (
          <div className="month__week" key={index}>
            {week.map((date, day_index) => renderCell(date, day_index))}
          </div>
        ))}
      </div>
    </div>
  );
}

export default MonthSection;
